<template>
  <div class="article-tag-list">
    <div v-if="tagList && tagList.length > 0" class="article-tag-list-wrapper">
      <TransitionGroup name="fade" tag="div" class="tags">
        <TagItem
          v-for="tag in tagList"
          :key="tag.id"
          :to="{ name: 'tagById', params: { locale: $i18n.localePath(), id: tag.id } }"
          :title="tag.name"
        >
          {{ tag.name }}
        </TagItem>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
import TagItem from '@/components/common/TagItem'

export default {
  name: 'ArticleTagList',
  components: {
    TagItem
  },
  directives: {},
  props: {
    tagList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.article-tag-list {
  &-wrapper {
    min-height: 48px;
    // border: solid 1px #ececec;
    padding: 48px 0;
  }

  .tags {
    text-align: left;
  }
}
@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  // As same as default
}

@media only screen and (max-width: 767.98px) {
  .article-tag-list {
    &-wrapper {
      padding: 24px 0;
    }
  }
}
</style>
